export default "__VITE_ASSET__B8oEqq$e__"